import { browser } from '$app/environment';
import { preloadCode, preloadData } from '$app/navigation';
import { page } from '$app/state';

const PRELOAD_PATHS = {
	collections: [
		// Load app code for chat interface early
		'chats/*',
		'chats',
		'prompts',
		'providers',
		'context',
		'memories',
		'tools'
	],
	settings: ['profile', 'appearance', 'data']
};

export function preloadFrequentRoutes() {
	// Load chat listing asap
	preloadData('/collections/chats');

	for (const [section, paths] of Object.entries(PRELOAD_PATHS)) {
		for (const path of paths) {
			const pathname = `/${section}/${path}`;
			preloadCode(pathname);
		}
	}
}

export function getLaunchIntoChats() {
	if (!browser) {
		return false;
	}

	if (page.url.pathname !== '/') {
		return;
	}

	const launchIntoChatsList = globalThis.localStorage.getItem('quill-launch-chats');
	return launchIntoChatsList === 'true';
}
